// styles
import styles from './tag.module.scss'

type TagProps = {
	readonly className?: string
	readonly label: string
	readonly theme?:
		| 'likely'
		| 'medium'
		| 'unlikely'
		| 'low'
		| 'moderate'
		| 'high'
		| string
}

const Tag = ({ className, label, theme }: TagProps): JSX.Element => {
	return (
		<span
			className={[styles.tag, className].join(' ').trim()}
			data-theme={theme}
		>
			{label}
		</span>
	)
}

export default Tag
